<template>
  <nav class="row g-0 align-items-center justify-content-center">
    <img class="brand-icon mr-2" :src="getHeaderImage()"/>
    <div v-if="userData" class="d-flex navbar-icon">
      <button v-on:click="onMenuIconClicked"
              class="menu-container navbar-toggler navbar-toggler-right d-flex justify-content-center align-items-center ml-4"
              type="button" id="nav-icon" v-bind:class="{open: isMenuOpen}">
        <div class="nav-icon-span-container">
          <span></span>
          <span></span>
          <span></span>
        </div>
      </button>
    </div>
    <div id="menu" v-if="userData" class="menu-panel">
      <ul class="menu-items row no-gutters list-group align-items-center">
        <li v-on:click="onHomeClicked()" class="menu-item nav-item py-2 row align-items-center no-gutters">
            <img src="../assets/vodacom/menu-home-icon-white.png" class="menu-icon">
            <span class="text menu-item-text">Home</span>
            <img src="../assets/vodacom/right-arrow-red.png" class="menu-icon-select">
        </li>
        <div class="row justify-content-center">
          <hr>
        </div>
        <li class="menu-item nav-item py-2 row align-items-center no-gutters">
          <a v-bind:href="this.$environmentConfig.fantasyHost" class="row align-items-center">
            <img src="../assets/vodacom/home-soccer-icon-white.png" class="menu-icon">
            <span class="text menu-item-text">Fantasy Football Home</span>
            <img src="../assets/vodacom/right-arrow-red.png" class="menu-icon-select">
          </a>
        </li>
        <div class="row justify-content-center">
          <hr>
        </div>
        <li v-on:click="onYourWinningsClicked()" class="menu-item nav-item py-2 row align-items-center no-gutters">
          <img src="../assets/vodacom/menu-trophy-icon-white.png" class="menu-icon">
          <span class="text menu-item-text">Your Winnings</span>
          <img src="../assets/vodacom/right-arrow-red.png" class="menu-icon-select">
        </li>
        <div class="row justify-content-center">
          <hr>
        </div>
<!--        <li v-on:click="onHowItWorksClicked()" class="menu-item nav-item py-2 row align-items-center no-gutters">-->
<!--          <img src="../assets/vodacom/menu-question-mark-icon-white.png" class="menu-icon">-->
<!--          <span class="text menu-item-text">How It Works</span>-->
<!--          <img src="../assets/vodacom/right-arrow-red.png" class="menu-icon-select">-->
<!--        </li>-->
        <div class="row justify-content-center">
          <hr>
        </div>
        <li v-on:click="termsAndConditionsClicked()" class="menu-item nav-item py-2 row align-items-center no-gutters">
          <img src="../assets/vodacom/menu-tandcs-icon-white.png" class="menu-icon">
            <span class="text menu-item-text">Terms & Conditions</span>
          <img src="../assets/vodacom/right-arrow-red.png" class="menu-icon-select">
        </li>
        <div class="row justify-content-center">
          <hr>
        </div>
      </ul>
    </div>
  </nav>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'Header',
  data: () => {
    return {
      isMenuOpen: false
    }
  },
  computed: {
    ...mapState(['userData'])
  },
  methods: {
    getHeaderImage() {
      return require(`../assets/${this.$environmentConfig.brand}/logo-200x200.png`)
    },
    onMenuIconClicked() {
      this.hideShowMenu();
    },
    hideShowMenu() {
      this.isMenuOpen = !this.isMenuOpen;
      document.querySelector('.menu-panel').classList.toggle('slide');
      if (this.isMenuOpen) {
        // document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'scroll';
      }
    },
    onHomeClicked() {
      this.$router.push('/sports');
      this.hideShowMenu();
    },
    onFantasyFootballClicked() {
      window.open(`${this.$environmentConfig.fantasyHost}`, '_self');
      this.hideShowMenu();
    },
    onYourWinningsClicked() {
      this.$router.push('your-winnings');
      this.hideShowMenu();
    },
    onHowItWorksClicked() {
      this.hideShowMenu();
    },
    termsAndConditionsClicked() {
      window.open('https://termsandconditions.vodacomfantasy.com/', '_blank');
      this.hideShowMenu();
    },
    onLogoutClicked() {
      window.alert('Logout functionality is in development.');
      this.hideShowMenu();
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
nav {
  background-color: $header-bg-color;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, .5);
  position: fixed;
  top: 0;
  left: 0;
  margin: 0;
  z-index: 1;
  height: 8vh;
  width: 100vw;
}

.brand-icon {
  height: 65%;
  width: auto;
}

#nav-icon {
  width: 50px;
  height: 50px;
  background: $header-bg-color;
  border-radius: 50%;
  display: flex !important;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .5s ease-in-out;
  -moz-transition: .5s ease-in-out;
  -o-transition: .5s ease-in-out;
  transition: .5s ease-in-out;
  cursor: pointer;
  padding: 0;
}

.nav-icon-span-container {
  position: absolute;
  width: 60%;
  display: flex;
  flex-direction: column;
}

#nav-icon span {
  display: block;
  height: 3px;
  width: 100%;
  margin-bottom: 3px;
  background: $menu-burger-color;
  border-radius: 9px;
  opacity: 1;
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: .25s ease-in-out;
  -moz-transition: .25s ease-in-out;
  -o-transition: .25s ease-in-out;
  transition: .25s ease-in-out;
  cursor: pointer;
}

#nav-icon span:nth-child(1) {
  top: 0;
}

#nav-icon span:nth-child(2) {
  top: 10px;
}

#nav-icon span:nth-child(3) {
  top: 20px;
}

#nav-icon.open span {
  position: absolute;
  top: 0;
  left: 0;
  width: 80%;
}

#nav-icon.open span:nth-child(1) {
  -webkit-transform: rotate(135deg);
  -moz-transform: rotate(135deg);
  -o-transform: rotate(135deg);
  transform: rotate(135deg);
}

#nav-icon.open span:nth-child(2) {
  opacity: 0;
  right: -60px;
}

#nav-icon.open span:nth-child(3) {
  -webkit-transform: rotate(-135deg);
  -moz-transform: rotate(-135deg);
  -o-transform: rotate(-135deg);
  transform: rotate(-135deg);
}

button {
  margin-left: 1rem;
  border: 0;
  outline: 0 !important;
  color: transparent;
}

button:focus {
  border: none;
  outline: none;
}

.navbar-icon {
  position: fixed;
  right: 0;
}

#menu {
  position: fixed;
  top: 8vh;
  transition: all 500ms ease;
  -webkit-transition: all 500ms ease;
  right: 100%;
  z-index: 10;
  background-color: $icon-container-background-color;
  color: #FFFFFF;
  width: 90vw;
  opacity: 0.95;
}

.slide {
  transform: translate3d(100%, 0, 0);
}

.menu-icon {
  width: auto;
  height: 2rem;
  margin: 0 0.8rem 0 0.8rem;
}

.menu-icon-select {
  position: absolute;
  right: 0.5rem;
  width: auto;
  height: 1.6rem;
}

.menu-item {
  text-align: left;
  position: relative;
}

.menu-item-text {
  position: absolute;
  left: 4.6rem;
}

@media screen and (max-width: 700px) {
  .menu-item-text {
    font-size: x-small;
  }
}

.menu-items {
  padding: 1rem 1rem 2rem 1rem;
  opacity: 0.95;
  z-index: 10;
}

hr {
  width: 90%;
  color: black;
  height: 1px;
  text-align: center;
  margin-bottom: 0 !important;
}

@media (min-width: 576px) {
  #menu {
    padding: 3rem;
  }
}
</style>
